import { defineMessages } from 'react-intl';

export const messages: {
	search: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	searchIconLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	search: {
		id: 'dynamic-cards-search-page.dropdown_search',
		defaultMessage: 'Search',
		description:
			'Subheading text displayed in the search input dropdown that presents the current query as a search action the user can click to run a full search.',
	},
	searchIconLabel: {
		id: 'dynamic-cards-search-page.dropdown_search_icon_label',
		defaultMessage: 'Search',
		description:
			'Label text for search icon shown in search input where user can click to type search query',
	},
});
